import React from 'react';
import { Menu } from 'antd';
import { useSetSelectedParam } from '../../model/selectedParam';
import { useSetModalVisible } from '../../model/modalState';
import { useAvailableParams } from '../../utils/availableParams';
import { useSelector } from 'react-redux';

const paramUpdater = (value) => (prev) => prev?.id === value.id ? prev : value;

const selectorUserInfo = (state) =>
  state.authentication.userInfo.CanChangeRequestStage;

const ParamsMenu = ({ onClick, ...props }) => {
  const params = useAvailableParams();

  const setSelectedParam = useSetSelectedParam();
  const setModalVisible = useSetModalVisible();

  const handleMenuClick = ({ item }) => {
    setSelectedParam(paramUpdater(item.props.value));
    setModalVisible(true);
    onClick();
  };

  const hasCanChangeRequestStage = useSelector(selectorUserInfo);

  return (
    <Menu
      {...props}
      onClick={handleMenuClick}
    >
      {params
        .filter((param) => param.id !== 8 || hasCanChangeRequestStage)
        .map((param) => (
          <Menu.Item
            key={param.id}
            value={param}
          >
            {param.name}
          </Menu.Item>
        ))}
    </Menu>
  );
};

export default ParamsMenu;
